import { render, staticRenderFns } from "./EBankPixTab.vue?vue&type=template&id=771fcbd6&"
import script from "./EBankPixTab.vue?vue&type=script&lang=js&"
export * from "./EBankPixTab.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/echope/echope-front/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('771fcbd6')) {
      api.createRecord('771fcbd6', component.options)
    } else {
      api.reload('771fcbd6', component.options)
    }
    module.hot.accept("./EBankPixTab.vue?vue&type=template&id=771fcbd6&", function () {
      api.rerender('771fcbd6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/components/tabs/EBankPixTab.vue"
export default component.exports